import { AccordionComponent, AccordionPanelComponent } from '@knorr-bremse-portals/ngx-components/components/accordion';
import { InputComponent } from '@knorr-bremse-portals/ngx-components/components/controls/input';
import { SelectComponent, SelectOptionComponent } from '@knorr-bremse-portals/ngx-components/components/controls/select';
import { CheckboxComponent } from '@knorr-bremse-portals/ngx-components/components/controls/checkbox';
import { RadioComponent, RadioOptionComponent } from '@knorr-bremse-portals/ngx-components/components/controls/radio';
import { TextareaComponent } from '@knorr-bremse-portals/ngx-components/components/controls/textarea';
import { ButtonComponent } from '@knorr-bremse-portals/ngx-components/components/button';
import { DurationPickerComponent } from '@knorr-bremse-portals/ngx-components/components/controls/duration-picker';
import { RangeComponent } from '@knorr-bremse-portals/ngx-components/components/controls/range';
import { TimePickerComponent } from '@knorr-bremse-portals/ngx-components/components/controls/time-picker';
import { ErrorComponent } from '@knorr-bremse-portals/ngx-components/components/controls/error';
import { LabelComponent } from '@knorr-bremse-portals/ngx-components/components/label';
import { HintComponent } from '@knorr-bremse-portals/ngx-components/components/controls/hint';
import { FooterComponent, FooterLinkComponent } from '@knorr-bremse-portals/ngx-components/components/footer';
import { ExtendedFooterComponent, FooterLinkSectionComponent, FooterIconLinkSectionComponent, FooterIconLinkComponent, FooterAddressComponent } from '@knorr-bremse-portals/ngx-components/components/footer/extended';
import { HeaderComponent, SiteNavigationComponent, NavigationContentDirective, HeaderSearchComponent, provideSiteNavigationIntl, provideHeaderSearchIntl } from '@knorr-bremse-portals/ngx-components/components/header';
import { HeaderTitleComponent } from '@knorr-bremse-portals/ngx-components/components/header/header-title';
import { LanguageSelectComponent } from '@knorr-bremse-portals/ngx-components/components/header/language-select';
import { RegionSelectComponent, provideRegionSelectIntl } from '@knorr-bremse-portals/ngx-components/components/header/region-select';
import { CalendarComponent, provideCalendarIntl } from '@knorr-bremse-portals/ngx-components/components/calendar';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { ChipComponent } from '@knorr-bremse-portals/ngx-components/components/chip';
import { ChipSetComponent } from '@knorr-bremse-portals/ngx-components/components/chip-set';
import { ClickMapComponent } from '@knorr-bremse-portals/ngx-components/components/click-map';
import { ColumnListComponent } from '@knorr-bremse-portals/ngx-components/components/column-list';
import { ContactComponent } from '@knorr-bremse-portals/ngx-components/components/contact';
import { DownloadLinkComponent } from '@knorr-bremse-portals/ngx-components/components/download-link';
import { FigureComponent } from '@knorr-bremse-portals/ngx-components/components/figure';
import { GalleryComponent, GalleryPageDirective, provideGalleryIntl } from '@knorr-bremse-portals/ngx-components/components/gallery';
import { GeneratedDownloadButtonComponent } from '@knorr-bremse-portals/ngx-components/components/generated-download-button';
import { HeroItemComponent } from '@knorr-bremse-portals/ngx-components/components/hero/hero-item';
import { HeroCarouselComponent, provideHeroCarouselIntl } from '@knorr-bremse-portals/ngx-components/components/hero/hero-carousel';
import { HeroPictureComponent } from '@knorr-bremse-portals/ngx-components/components/hero/hero-picture';
import { HeroVideoComponent } from '@knorr-bremse-portals/ngx-components/components/hero/hero-video';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp';
import { MainGridComponent } from '@knorr-bremse-portals/ngx-components/components/main-grid';
import { MarqueeComponent } from '@knorr-bremse-portals/ngx-components/components/marquee';
import { PanelContentComponent } from '@knorr-bremse-portals/ngx-components/components/panel-content';
import { PanelHeaderComponent } from '@knorr-bremse-portals/ngx-components/components/panel-header';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { PictureLightboxComponent } from '@knorr-bremse-portals/ngx-components/components/picture-lightbox';
import { ProgressIndicatorComponent } from '@knorr-bremse-portals/ngx-components/components/progress-indicator';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { TabGroupComponent, TabPanelComponent } from '@knorr-bremse-portals/ngx-components/components/tab-group';
import { TableComponent } from '@knorr-bremse-portals/ngx-components/components/table';
import { VariableHeadingComponent } from '@knorr-bremse-portals/ngx-components/components/variable-heading';
import { VideoComponent, provideVideoIntl } from '@knorr-bremse-portals/ngx-components/components/video';
import { VisualSectionComponent } from '@knorr-bremse-portals/ngx-components/components/visual-section';

const ControlComponents = [
    InputComponent,
    SelectComponent, SelectOptionComponent,
    CheckboxComponent,
    RadioComponent, RadioOptionComponent,
    TextareaComponent,
    ButtonComponent,
    DurationPickerComponent,
    RangeComponent,
    TimePickerComponent,
    ErrorComponent, LabelComponent, HintComponent,
];

const FooterComponents = [
    FooterComponent, FooterLinkComponent,
];
const ExtendedFooterComponents = [
    ...FooterComponents,
    ExtendedFooterComponent, FooterLinkSectionComponent, FooterIconLinkSectionComponent, FooterIconLinkComponent, FooterAddressComponent,
];

const HeaderComponents = [
    HeaderComponent,
    HeaderTitleComponent,
    SiteNavigationComponent,
    NavigationContentDirective,
    RegionSelectComponent,
    HeaderSearchComponent,
    LanguageSelectComponent,
];
function provideHeaderIntl(headerIntl) {
    return [
        provideSiteNavigationIntl(headerIntl.siteNavigation),
        provideRegionSelectIntl(headerIntl.regionSelect),
        provideHeaderSearchIntl(headerIntl.headerSearch),
    ];
}

const AllComponents = [
    ...ControlComponents,
    ...HeaderComponents,
    ...ExtendedFooterComponents,
    AccordionComponent, AccordionPanelComponent,
    ButtonComponent,
    CalendarComponent,
    CardComponent,
    ChipComponent,
    ChipSetComponent,
    ClickMapComponent,
    ColumnListComponent,
    ContactComponent,
    DownloadLinkComponent,
    FigureComponent,
    GalleryComponent, GalleryPageDirective,
    GeneratedDownloadButtonComponent,
    HeroCarouselComponent, HeroItemComponent, HeroPictureComponent, HeroVideoComponent,
    HtmlComponent,
    IconComponent,
    LabelComponent,
    LineClampComponent,
    MainGridComponent,
    MarqueeComponent,
    PanelContentComponent,
    PanelHeaderComponent,
    PictureComponent,
    PictureLightboxComponent,
    ProgressIndicatorComponent,
    StandaloneLinkComponent,
    TabGroupComponent, TabPanelComponent,
    TableComponent,
    VariableHeadingComponent,
    VideoComponent,
    VisualSectionComponent,
];
function provideIntl(intl) {
    return [
        ...provideHeaderIntl(intl),
        provideCalendarIntl(intl.calendar),
        provideGalleryIntl(intl.gallery),
        provideHeroCarouselIntl(intl.heroCarousel),
        provideVideoIntl(intl.video),
    ];
}

/**
 * Generated bundle index. Do not edit.
 */

export { AllComponents, ControlComponents, ExtendedFooterComponents, FooterComponents, HeaderComponents, provideHeaderIntl, provideIntl };
